import React from "react";
import {
  SectionTitle,
  SectionTitleBody,
  SectionTitleHeading,
  ButtonsContainer,
  HeadingType
} from "@silversea-ssc/ui-components-react";
import {
  SectionTitleCtAsFragment,
  SectionTitleFragment
} from "types/graphql-types";
import PageBuilderButtonCTA from "./PageBuilderButtonCTA";
import TextBox from "components/TextBox/TextBox";
import { useIsTabletOrDesktop } from "src/utils/useIsTabletOrDesktop";

type PageBuilderSectionTitleProps = SectionTitleFragment &
  SectionTitleCtAsFragment & { headingType?: HeadingType };

const PageBuilderSectionTitle: React.FC<
  React.PropsWithChildren<PageBuilderSectionTitleProps>
> = ({ tagline, title, content, ctaButtons = [], children, headingType }) => {
  const isDesktop = useIsTabletOrDesktop();

  if (!title?.localized && !content?.localized) return null;

  return (
    <SectionTitle variant={ctaButtons?.length == 0 ? "wide" : "column"}>
      {title?.localized && (
        <SectionTitleHeading
          priority={headingType == "H1" ? 1 : 2}
          tagline={tagline?.localized}
        >
          {title.localized}
        </SectionTitleHeading>
      )}
      {(content?.localized || ctaButtons?.length > 0) && (
        <SectionTitleBody>
          {content?.localized && (
            <TextBox
              fontSize={isDesktop ? "large" : "medium"}
              content={content.localized}
            />
          )}

          {children}

          {ctaButtons?.length > 0 && (
            <ButtonsContainer align="left" spacingTop="compact" mobileFullSize>
              {ctaButtons.map((b) => (
                <PageBuilderButtonCTA key={b?._key} {...b} />
              ))}
            </ButtonsContainer>
          )}
        </SectionTitleBody>
      )}
    </SectionTitle>
  );
};

export default PageBuilderSectionTitle;
